import { domToReact, Element, type HTMLReactParserOptions } from 'html-react-parser';

import useDetailModalStore, {
  DETAIL_MODAL_TYPE,
} from '@/stores/pure/DetailModalStore';
import { toast } from '@/stores/pure/ToastStore';

import { CitationBadge } from './citation-badge';

type MentionListModalOptions = {
  citation_ids: string[];
  chat_alias: string;
  message_id: string;
  report_alias?: string;
};

export const useParseOptions = ({
  chatAlias,
  clickEnabled = true,
  reportAlias,
}: {
  chatAlias: string;
  clickEnabled: boolean;
  reportAlias?: string;
}) => {
  const setNewModal = useDetailModalStore((state) => state.setNewModal);
  const modalStack = useDetailModalStore((state) => state.modalStack);

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (
        domNode instanceof Element &&
        domNode.name === 'a' &&
        domNode.attribs.class === 'citation'
      ) {
        const ids = domNode.attribs['data-ids'].split(',');
        const messageId = domNode.attribs['data-message-id'];

        const key = JSON.stringify({
          citation_ids: ids,
          chat_alias: chatAlias,
          message_id: messageId,
        });

        const isModalOpen = modalStack.some((modal) => key === modal.alias);

        return (
          <CitationBadge
            selected={isModalOpen}
            onClick={(e) => {
              if (!clickEnabled)
                return toast(
                  'Feedback is unavailable during analysis',
                  'normal',
                );

              e.preventDefault();

              setNewModal<MentionListModalOptions>({
                alias: key,
                type: DETAIL_MODAL_TYPE.HEY_SYNCLY_MENTION_LIST,
                options: {
                  citation_ids: ids,
                  chat_alias: chatAlias,
                  message_id: messageId,
                  report_alias: reportAlias,
                },
              });
            }}
          >
            {domToReact(domNode.children as any, options)}
          </CitationBadge>
        );
      }
    },
  };

  return {
    options,
  };
};
